export function updateSelectedMenu(sectionId) {
  if (sectionId) {
    return {
      type: "ACTIVE_LEFT_MENU",
      payload: { data: sectionId },
    };
  }
}

export function updateStoreList(data) {
  if (data) {
    return {
      type: "FETCH_STORES_SUCCESS",
      payload: { data: data },
    };
  }
}

export function collapseLeftMenu(data) {
  return {
    type: "COLLAPSE_LEFT_MENU",
    payload: { data: data },
  };
}
